import { createSlice } from '@reduxjs/toolkit';
import { memberLoginApi } from '../api/AuthApi';

const initialState = {
  user: null,
  member: JSON.parse(localStorage.getItem('memberData')) || null,
  token: localStorage.getItem('memberToken') || null,
  isAuthenticated: !!localStorage.getItem('memberToken'),
  loading: false,
  error: null,
  successMessage: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.member = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('memberToken');
      localStorage.removeItem('memberData');
      localStorage.removeItem('memberCredentials');
      localStorage.removeItem('token');
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
    // Check if user is still authenticated (for page refresh)
    checkAuth: (state) => {
      const token = localStorage.getItem('memberToken');
      const memberData = localStorage.getItem('memberData');
      if (token) {
        state.isAuthenticated = true;
        state.token = token;
        state.member = memberData ? JSON.parse(memberData) : null;
      } else {
        state.isAuthenticated = false;
        state.token = null;
        state.member = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Member Login
      .addCase(memberLoginApi.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(memberLoginApi.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.member = action.payload.member;
        state.token = action.payload.token;
        state.successMessage = action.payload.message;
        state.error = null;
      })
      .addCase(memberLoginApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.isAuthenticated = false;
        state.member = null;
        state.token = null;
        localStorage.removeItem('memberToken');
      });
  },
});

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout, 
  clearError, 
  clearSuccessMessage,
  checkAuth 
} = authSlice.actions;

export default authSlice.reducer;
